import {Component, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {IconButtonType} from "../../buttons/icon-button/icon-button";
import {SessionModel} from "../../orchestration/session.model";
import {ButtonShape} from "../../orchestration/app-entity.model";

@Component({
    selector: "woa-quantity-control",
    templateUrl: "./quantity-control.component.html"
})
export class QuantityControlComponent {
    @Input() decrementUnavailable: boolean;
    @Input() incrementUnavailable: boolean;
    @Input() decrementDisabled: boolean;
    @Input() incrementDisabled: boolean;
    @Input() minQuantity: number = 0;
    @Input() maxQuantity: number = Number.MAX_SAFE_INTEGER;
    @Input() quantity: number;
    @Input() transparent: boolean = false;
    @Input() readOnly: boolean = false;

    @Output() public onDecrement: EventEmitter<number> = new EventEmitter<number>();
    @Output() public onIncrement: EventEmitter<number> = new EventEmitter<number>();

    IconButtonType = IconButtonType;
    ButtonShape = ButtonShape;

    constructor(public sessionModel: SessionModel) {
    }

    @HostListener("click", ["$event"])
    onClick(event: MouseEvent) {
        event.stopPropagation();
    }

    decrement(): void {
        if (!(this.decrementDisabled || this.quantity <= this.minQuantity)) {
            this.onDecrement.emit();
        }
    }

    increment(): void {
        if (!(this.incrementDisabled || this.quantity >= this.maxQuantity)) {
            this.onIncrement.emit();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/quantity-control/quantity-control.component.ts